// import Auth from './auth'
import { CenteredSpinner } from '@portal/pkg-ui'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { Suspense } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import queryClient from '@config/QueryClient'
import { MercatusI18nextProvider } from '@config/MercatusI18nextProvider'
import MercatusThemeProvider from '@config/MercatusThemeProvider'
import { Router } from '@config/Router'
import { Zendesk } from '@config/Zendesk'

export default function App() {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <QueryClientProvider client={queryClient}>
        <MercatusI18nextProvider>
          {() => (
            <MercatusThemeProvider>
              <Router />
            </MercatusThemeProvider>
          )}
        </MercatusI18nextProvider>
        <Zendesk />
      </QueryClientProvider>
    </Suspense>
  )
}

library.add(fas)
